var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPercentDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    stroke: "currentColor",
    style: {
      fillOpacity: 0,
      strokeWidth: 1.69107,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path175",
    cx: 4.206954,
    cy: 7.9468307,
    rx: 2.6184275,
    ry: 2.6095629
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    stroke: "currentColor",
    style: {
      fillOpacity: 0,
      strokeWidth: 1.69107,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path175-8",
    cx: 12.864635,
    cy: 16.717505,
    rx: 2.6184275,
    ry: 2.6095629
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect372",
    width: 20.098675,
    height: 2.0098677,
    x: -12.688746,
    y: 13.742529,
    transform: "matrix(0.70494137,-0.70926558,0.70494137,0.70926558,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    style: {
      fillOpacity: 1,
      strokeWidth: 0,
      strokeDasharray: "none"
    },
    id: "rect372-8",
    width: 13.803242,
    height: 1.3,
    x: 5.9904871,
    y: -20.898758,
    transform: "rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    style: {
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.413756,
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect10773",
    width: 5.0642972,
    height: 1.3639435,
    x: -4.8661022,
    y: -28.788267,
    transform: "rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    style: {
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.413756,
      strokeLinejoin: "bevel",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect10773-6",
    width: 5.0345216,
    height: 1.4383858,
    x: -28.78392,
    y: -0.20246506,
    transform: "rotate(-135)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentDown);
export default __webpack_public_path__ + "static/media/percentDown.1b0f941e6607dbf92cb2b58783c3a2de.svg";
export { ForwardRef as ReactComponent };